var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.selection_sunday_reaction_component,{tag:"component",attrs:{"section":_vm.section}})}
var staticRenderFns = []

export { render, staticRenderFns }